import {
    ChatFileSchemaHandlers,
    LocaleIds,
} from "models/OrganizationModels/OrganizationMetadataConfiguration";
import { FieldsBySource } from "../types";

export enum ConditionalRuleType {
    Conditional,
    Concatenation,
    ValueAssignment,
}

export enum ConfigCreationSource {
    UI,
    API,
    Script,
}

export enum OrganizationMetadataFileType {
    "XML",
    "JSON",
    "CSV",
    "FILENAME",
    "AmazonConnect",
}

export enum CompareType {
    Exists,
    Equals,
    Contains,
}

// Where a source field's writes to. Mirrors OrganizationsController.TargetFieldKind, so if you
// change one, change the other.
// None means we only read the field, usually for a condition, and the backend does not save it. The
// condition already keeps its own copy of the path, so nothing is lost.
export enum TargetFieldKind {
    None = 0,
    Core = 1,
    Extended = 2,
}

export enum CompareEqConType {
    Equals,
    Contains,
}

export const compareTypeOptions = Object.values(CompareType)
    .filter((e) => typeof e === "number")
    .map((value) => ({
        label: CompareType[value],
        value,
    }));

export const compareEqConOptions = Object.values(CompareEqConType)
    .filter((e) => typeof e === "number")
    .map((value) => ({
        label: CompareEqConType[value],
        value,
    }));

export const localIdOptions = Object.values(LocaleIds)
    .filter((e) => typeof e === "number")
    .map((value) => ({
        label: LocaleIds[value],
        value,
    }));

export const metadataSourceOptions = [
    { label: "JSON", value: "JSON" },
    { label: "XML", value: "XML" },
    { label: "CSV", value: "CSV" },
    { label: "FileName", value: "FILENAME" },
    { label: "Amazon Connect", value: "AmazonConnect" },
    // Commenting these out because we don't have corresponding types on the backend yet
    // { label: "GenesysCloud", value: "GenesysCloud" },
    // { label: "Vonage", value: "Vonage" },
    // { label: "NiceCxOne", value: "NiceCxOne" },
    // { label: "Five9 Voice Stream", value: "Five9VoiceStream" },
];

// Get keys from enum - filter out numbers
export const chatFileSchemaOptions = [
    { label: "None", value: null },
    ...Object.values(ChatFileSchemaHandlers)
        .filter((e) => typeof e === "string")
        .map((handler) => ({
            label: handler,
            value: handler,
        })),
];

const GenesysCloudFields: FieldsBySource[] = [
    "configName",
    "agentCodeRequired",
];

const VonageFields: FieldsBySource[] = ["configName", "agentCodeRequired"];

const NiceCxOneFields: FieldsBySource[] = ["configName", "agentCodeRequired"];

const Five9VoiceStreamFields: FieldsBySource[] = [
    "configName",
    "agentCodeRequired",
];

const JSONFields: FieldsBySource[] = [
    "sourceType",
    "configName",
    "fileType",
    "fileTypeExtension",
    "chatFileSchemaHandler",
    "agentCodeRequired",
    "isDebug",
];

const XMLFields: FieldsBySource[] = [
    "configName",
    "fileType",
    "fileTypeExtension",
    "namespace",
    "prefix",
    "agentCodeRequired",
];

const CSVFields: FieldsBySource[] = [
    "sourceType",
    "configName",
    "fileType",
    "fileTypeExtension",
    "delimiter",
    "agentCodeRequired",
    "isDebug",
];

const FileNameFields: FieldsBySource[] = ["configName", "agentCodeRequired"];

export const sourceFieldsByType = {
    GenesysCloud: GenesysCloudFields,
    Vonage: VonageFields,
    NiceCxOne: NiceCxOneFields,
    Five9VoiceStream: Five9VoiceStreamFields,
    JSON: JSONFields,
    XML: XMLFields,
    CSV: CSVFields,
    FILENAME: FileNameFields,
};

export const integrationKeys = {
    AmazonConnect: ["amazon-access-key", "amazon-secret-key"],
    Twilio: ["twilio-basic-auth-username", "twilio-basic-auth-password"],
    NiceCx: [
        "nice-cx-access-key-id",
        "nice-cx-access-key-secret",
        "nice-cx-client-id",
        "nice-cx-client-secret",
    ],
};

export const hiddenValue = "********************";
